<div class="product-categories-responsive p-g-12">
   <app-confirm-dialog
      [visible]="deleteConfirmationVisible"
      variant="secondary"
      heading="Confirmation"
      message="Are you sure you want to Delete?"
      cancelText="No"
      (confirmed)="confirmCategoryDeletion()"
      (cancelled)="cancelCategoryDeletion()">
   </app-confirm-dialog>
   <div class="p-g-12">

      <div class="p-g">

         <div class="p-g-12 p-table-tecfolk-fix">

            <p-table [value]="categories" [rowHover]="true" [paginator]="true" [rows]="10" [responsive]="true"
               [loading]="loading" [first]="first" (onPage)="onPageChange($event)">

               <ng-template pTemplate="caption" style="text-align: left; background-color: #2f4050 !important;">
                  <div class="reportMainFilter">
                     <div class="reportMainFields">
                        <div class="filterFields">
                           <span class="fieldTitle">{{setLabel("searchByNameLabel")}}</span>
                           <input id="searchName" #searchName
                              style=" color: black ; height:30px ;outline: none; box-shadow: none; margin-right: 8px;"
                              autocomplete="off" pinputtext="" (keyup)="searchLocal(category.name, 'name')"
                              [(ngModel)]="category.name" [placeholder]='setLabel("searchHerePlaceholderLabel")'
                              type="text" name="name" class="p-inputtext p-corner-all p-state-default p-widget">
                        </div>
                        <div class="reportMainBtn">
                           <app-action-button
                              variant="secondary"
                               size="sm"
                              text="Clear"
                              icon="pi pi-times"
                              title="Clear"
                              ariaLabel="Clear"
                              [disabled]="loading"
                              (action)="clear()">
                           </app-action-button>
                           <div class="barBtnGap"></div>
                           <app-action-button
                              variant="secondary"
                               size="sm"
                              text="Add Category"
                              icon="pi pi-user-plus"
                              title="Add Category"
                              ariaLabel="Add Category"
                              routerLink="/product-category"
                              [disabled]="loading">
                           </app-action-button>
                        </div>
                     </div>
                  </div>
               </ng-template>

               <ng-template pTemplate="header">
                  <tr>
                     <th style="max-width: 90px;">{{setLabel("nameLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("descriptionLabel")}}</th>
                     <th style="max-width: 130px; text-align: center;">{{setLabel("actionsLabel")}}</th>
                  </tr>
               </ng-template>

               <ng-template pTemplate="body" let-rowData>
                  <tr (click)="viewProducts(rowData)" class="p-selectable-row" style="cursor: pointer;">
                     <td class="product-categories-td">
                        <div class="mobile-Lable">{{setLabel("nameLabel")}}</div>

                        <a href="javascript:void(0)" (click)="viewProducts(rowData); $event.stopPropagation()" style="color: #2196F3; font-weight: 600; text-decoration: none; cursor: pointer;">
                           {{rowData.name}}
                        </a>
                     </td>
                     <td class="product-categories-td">
                        <div class="mobile-Lable">{{setLabel("descriptionLabel")}}</div>

                        {{rowData.description}}
                     </td>
                     <td class="product-categories-td" style="text-align: center;">
                        <div class="mobile-Lable" style="text-align: justify;">{{setLabel("actionsLabel")}}</div>

                        <button pButton type="button" [pTooltip]='setLabel("deleteCategoryTooltipLabel")'
                           tooltipPosition="top" class="p-button-danger p-button-danger p-button" icon="fa fa-times"
                           (click)="deleteCategory(rowData); $event.stopPropagation()" style="margin-right: 5px;">
                        </button>
                        <button pButton type="button" [pTooltip]='setLabel("editCategoryTooltipLabel")'
                           tooltipPosition="top" icon="fa fa-pencil-square-o" (click)="editCategory(rowData); $event.stopPropagation()"
                           style="margin-right: 5px;">
                        </button>
                     </td>
                  </tr>
               </ng-template>

               <ng-template pTemplate="emptymessage" let-columns>
                  <tr style="color: black;">
                     <td>
                        {{setLabel("noRecordFoundLabel")}}
                     </td>
                  </tr>
               </ng-template>

            </p-table>
         </div>
      </div>
   </div>
</div>